import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { initialMapFiltersState } from "src/widgets/map/mapAddons/mapOverlayWidget/repairPlanOverlay/map.filters.config";

export type MapRepairPlanFilters = {
    RepairTypeStandartWorkType: any,
    RaionId: any,
}

type MapRepairPlanSlice = {
    filterMenuIsExpanded: boolean,
    filterMenuActiveTabs: number[],
    mapFiltersState: MapRepairPlanFilters,
    appliedFilters: MapRepairPlanFilters,
    mapFiltersExpressions: object | null,
    tableUnderMapFiltersExpressions: object | null,
    rankingThresholds: object | null
    rankingLoading: boolean
}

function getInitialState() {
    const mapsPreferences = getItemWebStorage("mapsPreferences")?.["RepairPlan"]
    const { mapFiltersState: localMapFiltersState, appliedFilters: localAppliedFilters, filterMenuActiveTabs: localFilterMenuActiveTabs } = mapsPreferences ?? {}
    const mapFiltersState: MapRepairPlanFilters = localAppliedFilters
        ? localMapFiltersState as MapRepairPlanFilters
        : initialMapFiltersState
    const initialState: MapRepairPlanSlice = {
        filterMenuIsExpanded: false,
        filterMenuActiveTabs: localFilterMenuActiveTabs,
        mapFiltersState,
        appliedFilters: localAppliedFilters,
        mapFiltersExpressions: null,
        tableUnderMapFiltersExpressions: null,
        rankingThresholds: null,
        rankingLoading: false
    };
    return initialState
}

export const mapRepairPlanSlice = createSlice({
    name: 'mapRepairPlan',
    initialState: getInitialState(),
    reducers: {
        setFilterMenuIsExpanded(state, action: PayloadAction<any>) {
            state.filterMenuIsExpanded = action.payload
        },
        setFilterMenuActiveTabs(state, action: PayloadAction<any>) {
            state.filterMenuActiveTabs = action.payload
        },
        setMapFiltersState(state, action: PayloadAction<any>) {
            state.mapFiltersState = action.payload
        },
        patchMapFiltersState(state, action: PayloadAction<{ fieldName: keyof MapRepairPlanFilters, patch: any }>,
        ) {
            const { fieldName, patch } = action.payload;
            state.mapFiltersState[fieldName] = { ...state.mapFiltersState[fieldName], ...patch };
        },
        resetAllMapFilters(state) {
            state.mapFiltersState = structuredClone(initialMapFiltersState)
        },
        resetSingleMapFilter(state, action: PayloadAction<keyof MapRepairPlanFilters>) {
            const fieldName = action.payload
            if (fieldName in initialMapFiltersState) {
                state.mapFiltersState[fieldName] = structuredClone(initialMapFiltersState[fieldName])
            }
        },
        setAppliedFilters(state, action: PayloadAction<any>) {
            state.appliedFilters = action.payload
        },
        setMapFiltersExpressions(state, action: PayloadAction<any>) {
            state.mapFiltersExpressions = action.payload
        },
        setTableUnderMapFiltersExpressions(state, action: PayloadAction<any>) {
            state.tableUnderMapFiltersExpressions = action.payload
        },
        setRankingThresholds(state, action: PayloadAction<any>) {
            state.rankingThresholds = action.payload
        },
        setRankingLoading(state, action: PayloadAction<boolean>) {
            state.rankingLoading = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setFilterMenuIsExpanded,
    setFilterMenuActiveTabs,
    setMapFiltersState,
    setAppliedFilters,
    patchMapFiltersState,
    resetAllMapFilters,
    resetSingleMapFilter,
    setMapFiltersExpressions,
    setTableUnderMapFiltersExpressions,
    setRankingThresholds,
    setRankingLoading
} = mapRepairPlanSlice.actions;
export const mapRepairPlanReducer = mapRepairPlanSlice.reducer;
